import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  Grid,
  IconButton,
  Link,
  Theme,
  Typography,
  makeStyles,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';

import { ReactComponent as EditIcon } from '../../../../assets/img/icon/Edit.svg';
// import Generic from '../../../../assets/img/self_inspection/foto-generica.png';
import Generic from '../../../../assets/img/inspections/generic_picture.svg';
import WhatsappSrc from '../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../assets/img/whatsapp.png';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../config/app';
import { useSelfInspectionDataContext } from '../../../../context/SelfInspection/selfInspection.provider';
import { useTipification } from '../../../../hooks/useTipification';
import {
  SELF_INSPECTIONS_QUERY,
  SELF_INSPECTIONS_QUERY_CONFIG,
  selfInspectionsQuery,
} from '../../../../query/selfInspections/selfInspections';

const useStyles = makeStyles((theme: Theme) => ({
  summaryImg: {
    objectFit: 'scale-down',
    position: 'relative',
    margin: '5px',
    borderRadius: '10px',
    display: 'flex',
    width: '300px',
    height: '150px',
  },
  iconImg: {
    margin: 5,
    position: 'absolute',
    top: -50,
    left: 150,
    width: 25,
    height: 25,
    color: 'tomato',
  },
  container: {
    display: 'flex',
    position: 'relative',
    alignContent: 'space-between',
  },
  modify: {
    position: 'absolute',
    right: 0,
    border: 'none',
    bottom: '30px',
    cursor: 'pointer',
    padding: '12px 24px',
    fontSize: '16px',
  },
  delete: {
    bottom: 30,
    left: 190,
    transform: 'translate(-50%, -50%)',
    msTransform: 'translate(-50%, -50%)',
    fontSize: '16px',
    padding: '12px 24px',
    border: 'none',
    cursor: 'pointer',
  },
  optionalLabel: {
    top: '5%',
    right: '5%',
    left: '5%',
    textAlign: 'right',
    position: 'absolute',
    fontWeight: 'bold',
    textShadow: '0 0 2px white',
  },
}));

const SelfInspectionSummary = () => {
  const {
    setStep,
    reset,
    selfInspectionBody,
    sendSelfInspection,
    success,
    errors,
    steps,
    selectedInspection,
  } = useSelfInspectionDataContext();

  const { data: selfInspections, isFetching } = useQuery(
    SELF_INSPECTIONS_QUERY,
    selfInspectionsQuery,
    SELF_INSPECTIONS_QUERY_CONFIG
  );

  const classes = useStyles();
  const history = useHistory();

  const [showIcons] = useState<any>(true);
  const [openSuccess, setOpenSuccess] = useState<any>(false);
  const [openError, setOpenError] = useState<any>(false);
  const [open, setOpen] = useState<any>(false);
  const [parts] = useState(
    steps
      .map((step: any) => step.part)
      .filter((part: any) => !!part && part.photo)
  );
  const { trackEvent, events } = useTipification();

  useEffect(() => {
    if (success.send_self_inspection) {
      setOpenSuccess(true);
      // nextStep();
    }
    if (errors.send_self_inspection) {
      setOpenError(true);
      // nextStep();
    }
  }, [errors, success]);

  const handleSubmit = async (event: any) => {
    trackEvent(events.STATUS_VEHICLE_INSPECTION_ANALYSIS);
    sendSelfInspection(selfInspectionBody);
    setOpen(false);
  };

  const editImg = (part: any) => {
    const index = steps.findIndex(
      (step: any) => step.part && step.part.id === part.id
    );

    if (index !== -1) {
      setStep(index);
    }
  };

  const { vehicle } = selectedInspection;

  const selftInspection = selfInspections?.pages
    ? selfInspections?.pages
        ?.flat()
        .filter(
          (selfInspection: any) =>
            selfInspection.vehicle.license_plate === vehicle.license_plate
        )
    : selfInspections?.filter(
        (selfInspection: any) =>
          selfInspection.vehicle.license_plate === vehicle.license_plate
      );

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Box>
              <Typography variant="h4">
                ¿Querés enviar las fotos de tu autoinspección?
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  onClick={handleSubmit}
                >
                  Sí, estoy seguro
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  No, continuar con la carga
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SharedDialog
        open={openSuccess}
        onClose={() => setOpenSuccess(false)}
        content={
          <Box>
            <Box mt={-2} mb={2}>
              <Typography variant="h6">
                Las fotos de tu autoinspección fueron enviadas correctamente
              </Typography>
            </Box>
            <Box mb={2}>
              <Typography variant="subtitle1">
                Tu inspeccion será evaluada en las próximas 96 horas hábiles
              </Typography>
            </Box>
            <Box mb={2} style={{ whiteSpace: 'nowrap' }}>
              <Typography variant="subtitle1">
                Ante cualquier duda, comunicate con nosotros por Whatsapp{' '}
                <Link
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Box display="inline">
                    <Typography display="inline" color="secondary">
                      {appConfig?.FORMATED_WHATSAPP}
                    </Typography>
                  </Box>
                </Link>
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12}>
              <Box m={2} display="flex" alignItems="center">
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    reset();
                    window.parent.postMessage({ return: 'overview' }, '*');
                  }}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <SharedDialog
        open={openError}
        onClose={() => setOpenError(false)}
        content={
          <Box>
            <Box mb={2}>
              <Typography variant="h6">Ha ocurrido un error.</Typography>
              <Typography variant="body2">
                ¡Lo sentimos! Esta autoinspección no puede procesarse. Por favor
                reintentá más tarde o comunicate con nosotros por Whatsapp para
                cargar tu inspección.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Link
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Button variant="outlined" fullWidth color="secondary">
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px' }}
                    />
                    <Typography display="inline">
                      Comunicarme vía Whatsapp
                    </Typography>
                  </Button>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpenError(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <Grid container>
        <Grid item xs={12}>
          <Box mt={3}>
            <Typography variant="body1"> Resumen </Typography>
          </Box>
          <Box my={2}>
            <Typography variant="h5">
              ¡Gracias por completar la inspección!
            </Typography>
          </Box>
          <Box mb={2}>
            <Typography variant="body1">
              Te informaremos su resultado.
            </Typography>
          </Box>
          <Box mb={5}>
            {isFetching ? (
              <Alert severity="warning">
                {' '}
                Te informamos que las imágenes estan siendo actualizadas — puede
                tomar unos segundos
              </Alert>
            ) : (
              <>
                <Alert severity="success">
                  {' '}
                  ¡Todas sus imágenes han sido correctamente cargadas!
                </Alert>
              </>
            )}
          </Box>
        </Grid>

        <Grid container>
          <Grid item xs={6} style={{ display: 'inline' }}>
            <Typography variant="body1">
              {vehicle.brand +
                ' ' +
                vehicle.model +
                ' - ' +
                vehicle.license_plate}
            </Typography>
          </Grid>
          {/* <Grid item xs={6} style={{ display: "inline" }}>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => setShowIcons(!showIcons)}
              >
                <Typography variant="body1" color="primary">
                  Editar
                  <CreateIcon />
                </Typography>
              </div>
            </Grid> */}
        </Grid>

        <Grid container spacing={1} direction="row">
          {selfInspections &&
            selftInspection[0].vehicle.parts.map((part: any, index: number) => (
              <Grid
                item
                key={index}
                style={{ position: 'relative' }}
                xs={12}
                sm={6}
                md={6}
                lg={4}
              >
                <img
                  key={part.id}
                  className={classes.summaryImg}
                  src={part.skipped ? Generic : part.photo || part.thumb}
                  alt={''}
                />
                <Typography variant="caption">
                  {part.description} {part.skipped && '(Omitida)'}
                </Typography>
                {showIcons && (
                  <IconButton
                    aria-label="edit"
                    className={classes.modify}
                    onClick={() => editImg(part)}
                  >
                    {' '}
                    <EditIcon />{' '}
                  </IconButton>
                )}
              </Grid>
            ))}
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          justify="center"
          style={{ marginBottom: '6rem' }}
        >
          <Box my={3} style={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              onClick={() => setOpen(true)}
              disabled={isFetching || !parts}
              variant="contained"
              color="primary"
            >
              Confirmar y volver al incio
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default SelfInspectionSummary;
